import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 3.999a1 1 0 0 1 .993.883L28 5v16a1 1 0 0 1-.884.993L27 22h-5v5a1 1 0 0 1-.884.993L21 28H5a1 1 0 0 1-.994-.883L4 26.999V11a1 1 0 0 1 .883-.993L5 9.999h5v-5a1 1 0 0 1 .883-.993L11 3.999zm-7.001 22v-14h-14v14zm-8-20h14v14h-4v-9l-.006-.117A1 1 0 0 0 21 10h-9z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCopy = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCopy);
export default Memo;
